import styled, { css } from 'styled-components';
import CONTENTO_ACCESSIBILITIES from '../../../../domain/ContentoAccessibilities';
import {
    iconAudioDescribed,
    iconSignInterpretation,
    regularWhite,
} from '../../../../ui-components/design-tokens';

export const StyledTopAreaVariantNoWrap = styled.span`
    white-space: nowrap;
`;

export const StyledTopAreaVariantLink = styled.a`
    color: ${regularWhite};
    text-underline-position: under;
`;

const getIcon = (accessibility) => {
    if (accessibility === CONTENTO_ACCESSIBILITIES.SIGN_INTERPRETED) {
        return iconSignInterpretation;
    }

    if (accessibility === CONTENTO_ACCESSIBILITIES.AUDIO_DESCRIBED) {
        return iconAudioDescribed;
    }

    return null;
};

export const StyledTopAreaVariantIcon = styled.span`
    ${(props) =>
        props.accessibility &&
        getIcon(props.accessibility) &&
        css`
        margin-right: 3px;
        vertical-align: middle;

        &:before {
            font-family: svt-icons;
            content: '${getIcon(props.accessibility)}';
        }
    `}
`;
